

export class ToolTipOptionSelectActiveOutputWithoutStatus implements IToolTipOptionSelectActiveOutputWithoutStatus {
    /** The auto-generated id of the tool tip option master master */
    tooltip_option_id!: number;
    /** The tool tip option name  with 255 character limit */
    tooltip_option_name!: string;

    constructor(data?: IToolTipOptionSelectActiveOutputWithoutStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tooltip_option_id = _data["tooltip_option_id"];
            this.tooltip_option_name = _data["tooltip_option_name"];
        }
    }

    static fromJS(data: any): ToolTipOptionSelectActiveOutputWithoutStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ToolTipOptionSelectActiveOutputWithoutStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tooltip_option_id"] = this.tooltip_option_id;
        data["tooltip_option_name"] = this.tooltip_option_name;
        return data; 
    }
}

export interface IToolTipOptionSelectActiveOutputWithoutStatus {
    /** The auto-generated id of the tool tip option master master */
    tooltip_option_id: number;
    /** The tool tip option name  with 255 character limit */
    tooltip_option_name: string;
}

